/**
 * Context Menu Components - Unified and Cleaned
 *
 * This module exports two main context menu components:
 *
 * 1. RealtorContextMenu - Simple context menu for PropertyActionButtons
 *    - Fixed set of 4 actions (Actualize, Duplicate, Archive, Add to Selection)
 *    - Follows specific UI design specs (40x40px trigger, specific styling)
 *    - Used in: PropertyActionButtons component
 *
 * 2. UniversalContextMenu - Advanced context menu for complex scenarios
 *    - Role-based action visibility (realtor, admin permissions)
 *    - Comprehensive feature set with property info display
 *    - Better error handling and portal management
 *    - Used in: ObjectCard component for realtors
 */

// Core context menu components
export {
  RealtorContextMenu,
  type RealtorContextMenuProps,
} from "./RealtorContextMenu";

export {
  UniversalContextMenu,
  type UniversalContextMenuProps,
} from "./UniversalContextMenu";

// Default export for backward compatibility
export { RealtorContextMenu as default } from "./RealtorContextMenu";

// Export hooks used by the components
export { useContextMenuActions } from "./hooks/useContextMenuActions";
